<dropdown-v2
  (itemSelect)="select($event)"
  [selectedItem]="selected"
  [items]="items"
  [attr.data-id]="field.key"
  placeholder="Select"
></dropdown-v2>
